var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { editorSlice } from 'app/stores/editor';
import { errorNotifier } from 'app/utils/error';
import { storage } from 'app/utils/localStorage';
import { fetchSigned } from 'app/utils/network';
export const loadNews = createAsyncThunk('editor/news', (_, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const showNewsPopup = configGet('showNewsPopup', true);
        if (!showNewsPopup) {
            return;
        }
        const news = yield fetchSigned('/api/news').then(data => {
            if (!Array.isArray(data)) {
                return null;
            }
            const now = dayjs();
            return data
                .filter(item => typeof item === 'object')
                .filter(item => {
                const isValidNewItem = typeof item.id === 'string' &&
                    typeof item.message === 'string' &&
                    typeof item.published === 'string';
                return isValidNewItem;
            })
                .filter(item => {
                const { id } = item;
                return !storage(`news-${id}`).get();
            })
                .filter(newsItem => {
                var _a;
                const publishedAt = dayjs(newsItem.published);
                // ignore if publish date is invalid
                if (!publishedAt.isValid()) {
                    return false;
                }
                // invalid if date is in future (not yet published)
                if (publishedAt.isAfter(now, 'date')) {
                    return false;
                }
                // invalid if publish date + ttl is before now
                const ttl = (_a = newsItem.ttl) !== null && _a !== void 0 ? _a : 2;
                const expiresAt = publishedAt.add(ttl, 'days');
                if (expiresAt.isBefore(now, 'date')) {
                    return false;
                }
                return newsItem;
            });
        });
        if (news && news.length) {
            dispatch(editorSlice.actions.setNews(news));
        }
    }
    catch (_error) {
        errorNotifier(_error);
    }
}));
export const dismissNews = createAsyncThunk('editor/dismissNews', (itemId, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    const dismissDate = dayjs().format('YYYY-MM-DD');
    storage(`news-${itemId}`).set(dismissDate);
    setTimeout(() => {
        dispatch(editorSlice.actions.removeNews({ ids: [itemId] }));
    }, 120);
}));
